const certificacao_educacao = {
	items: [
		{
			titulo: 'CPA-10',
			descricao: `
                É a Certificação Profissional ANBIMA – Série 10. Ela é feita para os gerentes de bancos e <br class="br_desk" />\n
                assessores de plataformas de investimento que atendem ao público de varejo em geral.
			`
		},
		{
			titulo: 'CPA-20',
			descricao: `
                Voltada para os profissionais que vendem produtos para clientes dos segmentos varejo alta renda, <br class="br_desk" />\n
                private, corporate e investidores institucionais – também chamada de Certificação Profissional ANBIMA – Série 20. <br class="br_desk" />\n
                Quem tem essa qualificação pode desempenhar as atividades da CPA-10.
			`
		},
		{
			titulo: 'CEA',
			descricao: `
                Quem quer assessorar gerentes de contas de clientes pessoas físicas precisa da Certificação de <br class="br_desk" />\n
                Especialista de Investimentos ANBIMA. Ela também abrange a CPA-10 e a CPA-20.
			`
		},
		{
			titulo: 'CGA',
			descricao: `
                Os profissionais que fazem a gestão de recursos de terceiros em veículos de investimentos (como fundos), <br class="br_desk" />\n
                incluindo compra e venda dos papéis da carteira, precisam da Certificação de Gestores ANBIMA.
			`
		}
	]
};

export { certificacao_educacao };
